import luxinLanguages from "@/statics/language.js";

luxinLanguages.ru = {
  title: "русский",
  short: "ru",
  isRTL: false,
  NODE2_INPUT1_NAME: "вход 1",
  NODE2_INPUT2_NAME: "вход 2",
  NODE2_OUTPUT1_NAME: "Выход 1",
  NODE2_OUTPUT2_NAME: "Выход 2",
  NODE3_INPUT1_NAME: "вход 1",
  NODE3_OUTPUT1_NAME: "Выход 1",
  NODE4_INPUT1_NAME: "вход 1",
  NODE4_INPUT2_NAME: "вход 2",
  NODE4_OUTPUT1_NAME: "Выход 1",
  NODE5_INPUT1_NAME: "вход 1",
  NODE5_OUTPUT1_NAME: "Выход 1",
  NODE6_INPUT1_NAME: "температура",
  NODE6_INPUT2_NAME: "влажность",
  Hub_Owner: "админ",
  Hub_User: "пользователь",
  Common_internetError: "просим проверить вашу интернет связь",
  Devices_addNewDevice: "добавление устройства",
  BottomNav_dashboard: "доска",
  BottomNav_devices: "устройства",
  BottomNav_settings: "сцены",
  Devices_Hub_Priviledge: "уровень допуска",
  Devices_Hub_IP: "IP адрес",
  Devices_Hub_accessOwner: "админ",
  Devices_Hub_accessNormal: "пользователь",
  Devices_noHubs: "куб не разыскивается!",
  Devices_noNodes: "для этого хаба устройства не найдены!",
  Device_serachPlaceHolder: "поиск",
  Devices_searchNotFound: "не нашли",
  LanguageSelect_selectLanguage: "выберите язык",
  LanguageSelect_submitButton: "подберите",
  LoginRegister_title: "зарегистрируйтесь",
  LoginRegister_text: "просим ввести номер своего мобильного",
  LoginRegister_button: "код отправки",
  LoginRegister_placeHolder: "номер мобильного",
  LoginRegister_back: "назад",
  LoginRegister_inputError: "неправильный номер мобильного",
  LoginRegister_serverResponseFail: "что-то неправильно! Проверьте свой номер и попробуйте ещё раз",
  LoginConfirmationCode_title: "код подтверждения",
  LoginConfirmationCode_text: "просим ввести свой код подтверждения",
  LoginConfirmationCode_failMessage: "это не тот код, который мы вам отправили!",
  LoginConfirmationCode_retry: "отправить вновь",
  LuxinIntro_Next: "следующий",
  LuxinIntro_Finish: "пошли",
  IntroSlide1_title: "приветствуем в Luxin",
  IntroSlide1_text: "отсюда вы можете легко использовать умный дом вашего Luxin",
  IntroSlide2_title: "интернет вещей",
  IntroSlide2_text: "вы можете проводить мониторинг и контролировать ваш дом из любого места в любое время!",
  IntroSlide3_title: "Luxin хаб",
  IntroSlide3_text: "в первую очередб вы должны присоединить контроллер умного дома",
  IntroSlide4_title: "присоединение к хабу",
  IntroSlide4_text: "если кто-нибудь уже создал ваш хаб попросите у него доступ",
  AddDevice_title: "добавение устройства",
  AddDevice_text: "если вы не первый, кто установит этот проект, сделайте второй вариант",
  AddDevice_button: "добавьте новое устройство",
  AddDevice_button2: "существующий проект доступа",
  AddNewDevice_title: "добавьте новое устройство",
  AddNewDevice_text: "нам нужен QR код, который нанесён на ваше устройство",
  AddNewDevice_button: "сканирование камеры",
  AddNewDevice_button2: "выберите библиотеку",
  AddNewDeviceScanQR_title: "режим сканирования камеры",
  AddNewDeviceScanQR_text: "укажите камеру на устройствах с QR кодом. Вы должны присвоить разрешение на камеру  для этой программы",
  AddNewDeviceScanQR_button: "опять сканирование",
  AddNewDeviceScanQR_loading: "просим подождать . . . ",
  AddNewDeviceScanQR_error: "неправильный QR код!",
  AddNewDeviceScanQR_NotAllowedError: "ошибка! Просим, прилоить разрешение на камеру для этого аппа",
  AddNewDeviceScanQR_NotFoundError: "ошибка!  Камера не найдена",
  AddNewDeviceScanQR_NotSupportedError: "ошибка! Камера не поддерживается",
  AddNewDeviceScanQR_NotReadableError: "ошибка! камера не читается",
  AddNewDeviceScanQR_OverconstrainedError: "ошибка!  Ограничения не удовлетворяют",
  AddNewDeviceScanQR_StreamApiNotSupportedError: "ошибка!  Поток не поддерживается",
  AddNewDeviceUploadQR_button: "выберите фото",
  AddNewDeviceUploadQR_title: "выберите фото QR кода",
  AddNewDeviceUploadQR_text: "просим выбрать QR код  Luxin, который  содержит фото",
  AddNewDeviceUploadQR_alert: "это фото не содержит действующий Luxin QR код. Просим попробовать ещё",
  AddDeviceNoHub_title: "предупреждение",
  AddDeviceNoHub_text: "у вас нет Luxin Hub в вашей апликации. Просим присоединиться к хабу",
  AddNewDeviceDuplicated_title: "ой!",
  AddNewDeviceDuplicated_text: "вы уже добавили это устройство",
  AddHub_title: "добавьте очаг",
  AddHub_text: "это 'Luxin Hub'. Для продолжения нажмите 'следующий'",
  AddHub_button: "следующий",
  AddHubTurnOn_title: "включител его",
  AddHubTurnOn_text: "присоедините его к источнику энергии и включите его при помощи применения тока кнопки",
  AddHubTurnOn_button: "следующий",
  AddHubLedCheck_title: "LED статус Hub",
  AddHubLedCheck_text: "у Hub LED рыжий и не блестит?",
  AddHubLedCheck_button: "да ",
  AddHubLedCheck_button2: "нет",
  AddHubLedError_title: "ой!",
  AddHubLedError_text: "у этого хаба уже есть ADMIN. Попросите администрацию добавить вас в качестве пользователя. Или можете переделать это хаб, как новый",
  AddHubLedError_button: "очаг перезагрузки",
  AddHubLedError_Cancel: "назад",
  AddHubReset_title: "очаг перезагрузки",
  AddHubReset_text:
    "нажмите на кнопку перезагрузки, которая находится на спинке за малым отверстием. Для замены ADMIN нажмите на кнопку, пока Hub-ом LED всетится красный свет /синий цвет и освободите. Для FACTORY RESET не выпускайте, пока LED светится быстро",
  AddHubReset_button: "следующий",
  AddHubSecurity_title: "параметры безопасности",
  AddHubSecurity_text: "вы можете применить двухфакторную авторизацию переставив пароль на вашей камере для обеспечения максимальной безопасности",
  AddHubSecurity_button: "выберите пароль",
  AddHubSecurity_button2: "мне не нужен пароль!",
  AddHubSetPassword_title: "два фактора автор",
  AddHubSetPassword_placeHolder: "пароль",
  AddHubSetPassword_placeHolder2: "подтверждение пароля",
  AddHubSetPassword_text: "это не пароль вашего счёта. Это пароль ващего хаба!",
  AddHubSetPassword_button: "следующий",
  AddHubSetPassword_alert_passwordEmpty: "просим ввести пароль!",
  AddHubSetPassword_alert_passwordNotMatch: "подтвеждение пароля не соответствует паролю!",
  AddHubNameColor_title: "создание хаба",
  AddHubNameColor_text: "просим подобрать имя и цвет для ващегго хаба",
  AddHubNameColor_placeHolder: "имя (дом, офис …)",
  AddHubNameColor_button: "следующий",
  AddHubNameColor_alert_nameEmpty: "просим ввести имя для вашего хаба",
  AddHubConnectWifi_title: "присоединение к хабу",
  AddHubConnectWifi_text: "просим пойти на Wi-Fi параметры вашего телефона и связаться затем с сетью. Затем вернитесь к этой апликации и выберите 'связь с хабом'.",
  AddHubConnectWifi_button: "присоединение к хабу",
  AddHubNotFound_Cancel: "отмена",
  AddHubNotFound_title: "ошибка связи!",
  AddHubNotFound_text: "к сожаление, в сязи с присоедниенем к вашему очагу возникла проблема. Просим, убедитель что вы связывайтесь с  Wi-Fi сети Hub и затем попробуйте вновь ",
  AddHubNotFound_button: "попробуйте ещё",
  AddHubSuccess_title: "успех",
  AddHubSuccess_text: "ваш  Luxin Hubуспешно добавлен к вашему аппу. Вы можете посмотреть и изменить параметры вашего хаба в вкладыше 'устройства'",
  AddHubSuccess_button: "завершение",
  AddNode2_title: "двойная замена освещения",
  AddNode2_text: "вы рассмотпели двойную замену освещени. Нажмите затем чтобы добавить это устройство в вашем умном доме",
  AddNode2_button: "следующий",
  AddNode3_title: "одна замена светильников",
  AddNode3_text: "вы рассмотпели одну замену освещени. Нажмите затем  чтобы добавить это устройство в вашем умном доме",
  AddNode3_button: "следующий",
  AddNode4_title: "замена Multiway освещения",
  AddNode4_text: "вы рассмотпели мультиваиную замену освещения. Нажмите затем  чтобы добавить  это устройство в вашем умном доме",
  AddNode4_button: "следующий",
  AddNode5_title: "изменение общего назначения",
  AddNode5_text: "вы рассмотпели  замену общего назначения. Нажмите затем  чтобы добавить  это устройство в вашем умном доме",
  AddNode5_button: "следующий",
  AddNode6_title: "сенсор температуры-влажности",
  AddNode6_text: "вы рассмотпели сенсор температуры-влажности. Нажмите затем  чтобы добавить  это устройство в вашем умном доме",
  AddNode6_button: "следующий",
  AddNodeSelectHub_title: "выберите хаб",
  AddNodeSelectHub_text: "просим подобрать хаб, который нужно подобрать для этого устройства",
  AddNodeNameColor_title: "изменение устройства",
  AddNodeNameColor_text: "просим выбрать имя и цвет для этого устройства",
  AddNodeNameColor_button: "добавление ",
  AddNodeNameColor_placeHolder: "название (Bedroon, кухня, ...)",
  AddNodeNameColor_alert_nameEmpty: "просим ввести имя для этого устройтсва",
  AddNodeNameColor_alert_duplicateNode: "это устройство уже добавлено!",
  AddNodeSuccess_title: "успех",
  AddNodeSuccess_text: "это устройство успешно добавлено к вашему умному дому. Для начала его применения разделите его с вашим центром в приложении 'устройства'",
  AddNodeSuccess_button: "завершение",
  AddNodeHubNotFound_title: "ошибка связи!",
  AddNodeHubNotFound_text: "к сожаление, в сязи с присоедниенем к вашему хабу возникла проблема. Просим, убедитель что вы связывайтесь с  Wi-Fi сети Hub и затем попробуйте вновь ",
  AddNodeHubNotFound_button: "попробуйте ещё",
  PairNode_title: "парное устройство",
  PairNode_text: "вы должны настроить это устройство при помощи Hub. Пока нажмите на кнопку 'пара', убедитесь, что ваш Hub включён и присоединён к вашему аппу",
  PairNode_button: "параметры безопасности",
  PairNode_button2: "удаление устройтсва",
  PairNodeSuccess_title: "успех",
  PairNodeSuccess_text: "это устройство успещно спарено с вашим Hub и готово к применению",
  PairNodeSuccess_button: "завершение",
  PairNodeHubNotResponding_title: "ошибка связи!",
  PairNodeHubNotResponding_text: "к сожаление, в сязи с присоедниенем к вашему хабу возникла проблема. Просим, убедитель что вы связывайтесь с  Wi-Fi сети Hub и затем попробуйте вновь ",
  PairNodeHubNotResponding_button: "попробуйте ещё",
  PairNodeNodeNotResponding_title: "ошибка связи устройства!",
  PairNodeNodeNotResponding_text: "ваш хаб не сможет коммуникацию с этим устройством. Просим убедиться, что устройство включено",
  PairNodeNodeNotResponding_button: "попробуйте ещё",
  Node2Settings_title1: "замена устройства",
  Node2Settings_title2: "информация об устройстве",
  Node2Settings_title3: "режимы по умолчанию",
  Node2Settings_button: "сохранение изменений",
  Node2Settings_button2: "удаление устройтсва",
  Node2Settings_text1: "имя ",
  Node2Settings_default1: "то же обячно открыто",
  Node2Settings_default2: "то же обячно закрыто",
  Node2Settings_default3: "крест обыно открыт",
  Node2Settings_default4: "крест обыно закрыт",
  Node3Settings_default1: "обычно открыт",
  Node3Settings_default2: "обычно закрыт",
  Node4Settings_default1: "ввод мультивера",
  Node2Settings_deviceStatus: "статус",
  Node2SettingsHubNotResponding_title: "ошибка связи!",
  Node2SettingsHubNotResponding_text: "к сожаление, в сязи с присоедниенем к вашему хабу возникла проблема. Просим, убедитель что вы связывайтесь с  Wi-Fi сети Hub и затем попробуйте вновь ",
  Node2SettingsHubNotResponding_button: "назад",
  Node2SettingsSuccess_title: "успех",
  Node2SettingsSuccess_text: "новые параметры успешно сохранены на вашем устройстве",
  Node2SettingsSuccess_button: "назад",
  Node2SettingsNodeNotResponding_title: "ишибка связи устройства!",
  Node2SettingsNodeNotResponding_text: "ваш хаб не сможет коммуникацию с этим устройством. Просим убедиться, что устройство включено",
  Node2SettingsNodeNotResponding_button: "назад",
  Node2Settings_alert: "присим ввести новое имия для этого устройства",
  DeleteDevice_title: "предупреждение!",
  DeleteDevice_text: "вы собираетесь удалить это устройство. Для того, чтобы добавить ещё раз вы должны ввести QR код на его этикет. Вы уверены?",
  DeleteDevice_button: "да ",
  DeleteDevice_button2: "нет",
  DeleteDeviceSuccess_title: "успех",
  DeleteDeviceSuccess_text: "это устройство успешно удалено из вашего умного дома",
  DeleteDeviceSuccess_button: "назад",
  RelaySSR2ASettings_title1: "выход",
  RelaySSR2ASettings_text1: "состояние выхода",
  RelaySSR2ASettings_switchState_On: "включённый",
  RelaySSR2ASettings_switchState_Off: "выключен",
  RelaySSR2ASettings_title2: "параметры выхода",
  RelaySSR2ASettings_text2: "тип выхода",
  RelaySSR2ASettings_text3: "имя ",
  RelaySSR2ASettings_text4: "начальное состояние",
  RelaySSR2ASettings_button: "сохранение изменений",
  RelaySSR2ASettings_initState1: "включённый",
  RelaySSR2ASettings_initState2: "выключен",
  RelaySSR2ASettings_outputType1: "освещение",
  RelaySSR2ASettings_outputType2: "орошение",
  RelaySSR2ASettings_outputType3: "куллер",
  RelaySSR2ASettings_outputType4: "отопление",
  RelaySSR2ASettings_outputType5: "дверь",
  RelaySSR2ASettings_alert: "прсим ввести имя для этого выходящего продукта",
  ZeroContactSettings_title1: "ввод  ",
  ZeroContactSettings_text1: "состояние воода",
  ZeroContactSettings_title2: "параметры ввода",
  ZeroContactSettings_text2: "тип воода",
  ZeroContactSettings_inputType1: "нормальная замена",
  ZeroContactSettings_inputType2: "нажмите на кнопку",
  ZeroContactSettings_inputType3: "детектор дыма",
  ZeroContactSettings_inputType4: "детектор присутствия",
  ZeroContactSettings_text3: "имя ввода",
  ZeroContactSettings_text4: "направление",
  ZeroContactSettings_alert: "просим ввести имя для этого воода",
  ZeroContactSettings_button: "сохранение изменений",
  ZeroContactSettings_text5: "воздействие",
  HubSettings_title1: "замена устройства",
  HubSettings_text1: "имя",
  HubSettings_title2: "управляйте хабом",
  HubSettings_button: "сохранение изменений",
  HubSettings_button2: "удалите хаб",
  HubSettings_alert: "просим указать имя для этого хаба",
  HubSettings_title3: "статус",
  HubSettings_button3: "обновление firmware",
  HubSettings_button4: "управляйте пользователем",
  HubSettings_button5: "управляйте Wi-Fi сетью",
  DeleteHub_title: "удалите хаб",
  DeleteHub_text:
    "вы собираетесь удалить этот хаб. Если вы продолжите, будут удалены также все устройства, связанные с этим аппом. Вам нужно применить пароль этого UUID, чтобы вновь связаться с ним. Вы уверены?",
  DeleteHub_button: "да ",
  DeleteHub_button2: "нет",
  OTA_title: "обновление firmware",
  OTA_text:
    "этим вы обновите програмное обеспечение хаба в новейшей версии. Убедитесь, что ваш хаб с интернетом и стабильным электрообеспечением. Не отключайте ваш хаб в процессе. Вы уверены, что желаете продолжить?",
  OTA_button: "да ",
  OTA_button2: "нет",
  OtaSuccess_title: "успех",
  OtaSuccess_text: " firmwareвашего хаба обновлён. Просим не отключать хаб и дождитесь, пока LED хаба прекратить быстрое мигание. Затем перезагрузите",
  OtaSuccess_button: "выполнено",
  HubNetworkSettings_title: "параметры сети",
  HubNetworkSettings_text1: "тип сети",
  HubNetworkSettings_text2: "WiFi имя (SSID)",
  HubNetworkSettings_text3: "Wi-Fi пароль",
  HubNetworkSettings_alert: "ваше пребование не может быть выполнено. Попробуйте ещё",
  HubNetworkSettings_button: "сохранение изменений",
  HubNetworkSettings_alert2: "прсим ввести имясети",
  HubNetworkSettingsSuccess_title: "успех",
  HubNetworkSettingsSuccess_text: "Wi-Fiхаба успешно изменён. Прсим изменить WiFi параметры ващего телефона и связаться с сетью Hub",
  HubNetworkSettingsSuccess_button: "выполнено",
  HubUserSettings_title: "пользователь",
  HubUserSettings_button: "добавьте нового пользователя",
  EditUser_title1: "изменение пользователя",
  EditUser_text1: "номер мобильного",
  EditUser_text2: "уровень допуска",
  EditUser_text3: "имя пользователя",
  EditUser_button1: "удаление пользователя",
  EditUser_button2: "сохранение изменений",
  EditUser_alert: "просим ввести имя для этого пользователя",
  EditUser_ownerText: "админ",
  EditUser_normalText: "пользователь",
  AddNewUser_title: "добавьте нового пользователя",
  AddNewUser_text: "добавление нового пользователя. Просим ввести номер мобильного и имя нового пользователя",
  AddNewUser_placeHolder: "номер мобильного",
  AddNewUser_placeHolder2: "имя",
  AddNewUser_button: "добавьте гового пользователя",
  AddNewUser_alert1: "просим ввести номер мобильного нового пользоателя",
  AddNewUser_alert2: "просим ввести имя нового пользоателя",
  AddNewUser_alert3: "пользователь уже зарегистрирован",
  AddNewUser_serverResponseFail: "требование не может быть осуществлено. Просим проверить номер мобильного и постараться заново.",
  NewUserCredentials_title: "новый пользователь",
  NewUserCredentials_text: "новый пользователь успешно добавлен к вашему хабу. Он может войти в ваш хаб вволя эти полномочия. Просим сохранить эту страницу и отправить новому пользователю",
  NewUserCredentials_button: "завершение",
  DeleteUser_title: "удаление пользователя",
  DeleteUser_text: "вы уверены, что хотите удалить этого пользователя с вашего хаба?",
  DeleteUser_button: "да ",
  DeleteUser_button2: "нет",
  HubLogin_title: "присоединение к хабу",
  HubLogin_text: "просим убедиться, что вы находитесь в  той же Wi-Fi сети, что и Hub и введите ваши сертификаты авторизации, которые даны администратором этого хаба",
  HubLogin_placeHolder: "",
  HubLogin_placeHolder2: "пароль",
  HubLogin_button: "присоединение  ",
  HubLogin_alert1: "просим ввести UUID центр",
  HubLogin_alert2: "просим ввести ваш пароль",
  HubLogin_alert3: "вы уже присоединены к этому хабу",
  HubLoginSuccess_title: "успех",
  HubLoginSuccess_text: "вы сейчас присоединены к этому хабу",
  HubLoginSuccess_button: "завершение",
  HubLoginNotFound_title: "вход в систему не осуществлён",
  HubLoginNotFound_text: "апп не может присоединиться к этому хабу. Просим убедиться, что вы присоеденены к той же Wi-Fi  сети и проверьте UUID поле",
  HubLoginNotFound_button: "попробуйте ещё",
  HubLoginError_title: "вход в систему не осуществлён",
  HubLoginError_text: "этот хаб не принимает ваш пароль. Просим попробовать ещё раз или связаться с администрацией хаба",
  HubLoginError_button: "попробуйте ещё",
  MainMenu_title: "главное меню",
  MainMenu_button1: "выбор языка",
  MainMenu_button2: "выход",
  LogOut_title: "выход",
  LogOut_text: "вы уверены, что хотите покинуть систему?",
  LogOut_button: "да ",
  LogOut_button2: "нет",
  TemperatureSensorSettings_title1: "ввод",
  TemperatureSensorSettings_text1: "температура",
  TemperatureSensorSettings_title2: "параметры ввода",
  TemperatureSensorSettings_text3: "имя ввода",
  TemperatureSensorSettings_button: "сохранение изменений",
  HumiditySensorSettings_title1: "ввод",
  HumiditySensorSettings_text1: "влажность",
  HumiditySensorSettings_title2: "параметры ссода",
  HumiditySensorSettings_text3: "имя ввода",
  HumiditySensorSettings_button: "сохранение изменений",
  DashBoard_noWidgets: "виджеты не найдены",
  Dashboard_editWidgets: "редактирование",
  DashBoard_addWidget: "добавление нового виджета",
  Dashboard_doneEditing: "сохранение",
  LuxinWidget_singleSwitch: "одноразовое изменение",
  DeleteWidget_title: "удаление виджета",
  DeleteWidget_text: "вы уверены, что хотите удалить этот выджет?",
  DeleteWidget_button: "да ",
  DeleteWidget_button2: "нет",
  Scenarios_addScenario: "добавление сцены",
  Scenarios_noscenario: "сцены не найдены",
  AddScenario_title1: "изменение сцены",
  AddScenario_text1: "имя",
  Scenario_namePlaceHolder: "имя сцены",
  AddScenario_button: "сохранение",
  AddScenario_alert1: "просим ввести имя для этой сцены",
  Scenarios_scenarioCommonName: "сцена",
  EditScenario_deleteButton: "уделение сцены",
  EditScenario_text5: "хаб",
  DeleteScenario_title: "уделение сцены",
  DeleteScenario_text: "вы уверены, что хотите удалить эту сцену?",
  DeleteScenario_button: "да ",
  DeleteScenario_button2: "нет",
  EditWidget_title1: "персональное создание виджета",
  Name_text: "имя",
  WidgetName_PlaceHolder: "имя виджета",
  SaveChanges_button: "сохранение изменений",
  Output_text: "выход",
  ChooseHub_text: "выберите хаб",
  ChooseOutput_text: "выберите выход",
  WidgetName_alert: "просим ввести имя виджета",
  AddNewWidget_button: "добавление",
  AddNewWidget_singleSwitchDescription: "одно изменение для контроля результаты включения/выключения при помощи прямого обратного присоединения",
  Save_button: "сохранение",
  TemperatureSensorSettings_title3: "условия",
  TemperatureSensorSettings_unknownScenario: "незнакомый сценарий",
  TemperatureSensorSettings_title4: "добавьте состояние",
  TemperatureSensorSettings_rising: "повышается",
  TemperatureSensorSettings_falling: "понижается",
  TemperatureSensorSettings_text2: "тип состояния",
  TemperatureSensorSettings_text4: "выберите сценарий",
  TemperatureSensorSettings_button2: "добавьте состояние",
  TemperatureSensorSettings_button3: "сохранение условий",
  TemperatureSensorSettings_button4: "добавьте сценарий",
  HubSettings_title4: "база данных",
  HubSettings_button6: "база данных синхронизации",
  HubSettings_button7: "сохранение базы данных",
  DeleteUser_serverError: "ошибка сервера. Просим попробовать позже",
  HubSettings_serverError: "ошибка сервера. Просим попробовать позже",
  HubSettings_noSnapshotsFound: "ни однин снимок не найден",
  AddNewWidget_sceneButtonDescription: "кнопка для запуска вашей персональной сцены",
  LuxinWidget_sceneButton: "кнопка сцены",
  SceneButton_runScene: "пробег",
  AddSceneButtonWidget_button: "сохранение",
  EditSceneButtonWidget_button: "сохранение",
  DeleteDevice_alert: "у вас нет доступа к этому действию",
  Node2Settings_default5: "тот же рычаг (переключатель)",
  Node2Settings_default6: "поперечный рычаг",
  Node3Settings_default3: "Toggle",
  HubNetworkSettings_alert3: "просим ввести пароль сети",
  AddNewDeviceUploadQR_alert2: "фото не содержит QR код",
  AddNewDeviceUploadQR_alert3: "при сканировании вашего QR кода возникла проблема",
  AddNode7_title: "IR Controller",
  AddNode7_text: "You've scanned an IR Controller. Hit next to add this device to your smart home.",
  AddNode7_button: "Next",
  NODE7_INPUT1_NAME: "Temperature",
  NODE7_INPUT2_NAME: "Humidity",
  Node7Settings_IrDevice: "IR Device",
  Node7Settings_addIrDevice: "Add IR Device",
  AddIrDevice_title1: "Customize",
  AddIrDevice_text1: "Name",
  AddIrDevice_namePlaceHolder: "IR Device Name",
  AddIrDevice_button: "Save",
  AddIrDevice_title2: "Select Device",
  AddIrDevice_text2: "Device Type",
  AddIrDevice_text3: "Brand",
  NODE7_AC_NAME: "Split",
  AddIrDevice_text4: "Model",
  AddIrDevice_testDevice: "Test Device",
  AddIrDevice_text5: "Please point your IR controller to your target device and select 'Test Device'. It your target device reacted, then hit 'Save', if not, try other models.",
  AddIrDevice_alert1: "Please enter device name",
  IrDeviceSettings_button2: "Delete IR Device",
  DeleteIrDevice_title: "Delete Ir Device",
  DeleteIrDevice_text: "Are you sure you want to delete this IR device?",
  DeleteIrDevice_button: "Yes",
  DeleteIrDevice_button2: "No",
  IrDeviceSettings_title3: "Remote Controller",
  IrDeviceSettings_showRemote: "Show Remote Controller",
  AddIrDevice_turnDeviceOff: "Turn Off",
  DashBoard_scehdule: "Schedules",
  weekDays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  weekDaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  AddSchedule_title1: "Customize",
  AddSchedule_text1: "Name",
  AddSchedule_namePlaceHolder: "Schedule Name",
  AddSchedule_text2: "Select Hub",
  AddSchedule_text3: "Hour",
  AddSchedule_text4: "Minute",
  AddSchedule_title2: "Time Select",
  AddSchedule_button: "Save",
  AddSchedule_text5: "Repeat",
  AddSchedule_title3: "Create Command",
  AddSchedule_button2: "Add Scene",
  AddSchedule_alert1: "Please enter a name for this schedule.",
  Schedules_schedule: "Schedule",
  Schedules_button: "Add Schedule",
  Schedules_loadError: "Problem loading schedules",
  Schedules_noSchedule: "No Schedules were found",
  Schedules_time: "Time: ",
  Schedules_repeat: "Repeat: ",
  AddScheduleSuccess_title: "Success",
  AddScheduleSuccess_text: "Your schedule has successfully been added to system.",
  AddScheduleSuccess_button: "Finish",
  Schedules_todayOnly: "Today Only",
  DeleteSchedule_title: "Delete Schedule",
  DeleteSchedule_text: "Are you sure you want to delete this schedule?",
  DeleteSchedule_button: "Yes",
  DeleteSchedule_button2: "No",
  Schedules_alert: "You have no hubs installed.",
  RelaySSR2ASettings_switchState_Unknown: "Loading...",
  CommandCreator_title2: "Commands",
  CommandCreator_title3: "Create Command",
  CommandCreator_text2: "Output Select",
  CommandCreator_text3: "Output State",
  CommandCreator_text4: "Delay (seconds)",
  CommandCreator_outputStateOn: "ON",
  CommandCreator_outputStateOff: "OFF",
  CommandCreator_outputStateToggle: "Toggle",
  CommandCreator_button2: "Add Command",
  CommandCreator_outputStateTitle: "State",
  CommandCreator_delayTitle: "Delay",
  CommandCreator_delaySecond: "Second(s)",
  CommandCreator_alert2: "Please create at least one command.",
  CommandCreator_text5: "Select Hub",
  CommandCreator_alertNoOutputs: "No outputs found for the selected Hub",
  NoOutPutForHub_alert: "No outputs found for the selected Hub",
  NoInstalledHub_alert: "You don't have any installed Hubs.",
  CommandCreator_alertNoHubs: "You don't have any installed Hubs.",
  CommandCreator_alertPacketOverflow: "Your command length exceeds the limit.",
  CommandCreator_button3: "Create Command",
  AddTemperatureAutomationWidget_title1: "Customize Widget",
  AddTemperatureAutomationWidget_text1: "Name",
  AddTemperatureAutomationWidget_namePlaceHolder: "Widget Name",
  AddTemperatureAutomationWidget_title2: "Automation Settings",
  AddTemperatureAutomationWidget_automationType1: "Heat and Cool",
  AddTemperatureAutomationWidget_automationType2: "Cool",
  AddTemperatureAutomationWidget_automationType3: "Heat",
  AddTemperatureAutomationWidget_text2: "Automation Type",
  AddTemperatureAutomationWidget_text3: "Season select",
  AddTemperatureAutomationWidget_targetSeason1: "Summer",
  AddTemperatureAutomationWidget_targetSeason2: "Winter",
  AddTemperatureAutomationWidget_text4: "Temperature Sensor Select",
  AddTemperatureAutomationWidget_text5: "Select Hub",
  AddTemperatureAutomationWidget_cool_on_description: "Please create the command to turn your cooling system on",
  AddTemperatureAutomationWidget_cool_off_description: "Please create the command to turn your cooling system off",
  AddTemperatureAutomationWidget_heat_on_description: "Please create the command to turn your heating system on",
  AddTemperatureAutomationWidget_heat_off_description: "Please create the command to turn your heating system off",
  AddTemperatureAutomationWidget_cool_text: "Cooling Output",
  AddTemperatureAutomationWidget_heat_text: "Heating Output",
  AddTemperatureAutomationWidget_button: "Save",
  AddTemperatureAutomationWidget_alertNoSensor: "No temperature sensor found in your selected hub.",
  AddTemperatureAutomationWidget_alertCoolOnNoCommand: "Please create the command to turn your cooling system on",
  AddTemperatureAutomationWidget_alertCoolOffNoCommand: "Please create the command to turn your cooling system off",
  AddTemperatureAutomationWidget_alertHeatOnNoCommand: "Please create the command to turn your heating system on",
  AddTemperatureAutomationWidget_alertHeatOffNoCommand: "Please create the command to turn your heating system off",
  AddTemperatureAutomationWidget_alertHubFailed: "Error connecting to target Hub. Please make sure you are connected to target Hub.",
  AddTemperatureAutomationWidget_alertSensorFailed: "Error connecting to temperature sensor. Your automation is added but please make sure your temperature sensor is turned on.",
  LuxinWidget_temperatureAutomation: "Temperature Automation",
  TemperatureAutomationWidget_alertSensorFailed: "Operation was successful but please make sure your temperature sensor is turned on.",
  EditSingleSwitchWidget_alertNotSync: "Could not load commands because your app is not synced. Please sync your database.",
  AddNewWidget_temperatureAutomationDescription: "Full control over cooling and heating systems",
  AddTemperatureAutomationWidget_alertNotOwner: "Sorry, Only Hub's owner can set automations.",
  EditTemperatureAutomationWidget_alertNotOwner: "Sorry, Only Hub's owner can edit automations.",
  DeleteTemperatureAutomation_title: "Delete Temperature Automation",
  DeleteTemperatureAutomation_text: "Are you sure you want to delete this automation? After deleting, this automation will no longer function.",
  DeleteTemperatureAutomation_button: "Yes",
  DeleteTemperatureAutomation_button2: "No",
  DeleteTemperatureAutomation_alertNotOwner: "Sorry, Only Hub's owner can delete automations.",
  DeleteTemperatureAutomation_alertDeleteError: "Oops, something went wrong.",
  DeleteTemperatureAutomation_alertSensorFailed: "Error connecting to your temperature sensor. Your automation is deleted but please make sure your temperature sensor is turned on.",
  HubNetworkSettings_alert4: "Password should be at lesat 8 characters.",
  Schedules_commands: "Commands: ",
  Schedules_showCommands: "Show Comamnds",
  AddSchedule_alert5: "You should create a command for this schedule.",
  AddSchedule_alert6: "You cannot add more schedules.",
  DeleteSchedule_alertDeleteError: "Oops, something went wrong.",
  Schedules_everyDay: "Everyday",
  AddSchedule_text6: "Next Occurrence",
  AddSchedule_button3: "Delete",
  AddNode9_title: "RGBW Controller",
  AddNode9_text: "You've scanned an RGBW Controller. Hit next to add this device to your smart home.",
  AddNode9_button: "Next",
  NODE9_INPUT1_NAME: "Input 1",
  NODE9_OUTPUT1_NAME: "RGB",
  NODE9_OUTPUT2_NAME: "Red",
  NODE9_OUTPUT3_NAME: "Green",
  NODE9_OUTPUT4_NAME: "Blue",
  NODE9_OUTPUT5_NAME: "White",
  Node9Settings_hue: "HUE",
  Node9Settings_rgbw: "RGBW",
  Node9Settings_rgb: "RGB",
  Node9Settings_red: "Red",
  Node9Settings_green: "Green",
  Node9Settings_blue: "Blue",
  Node9Settings_white: "White",
  Node9Settings_alert1: "Hub Connection Error!",
  Node9Settings_fadeTime: "Fade Time (ms)",
  Node9Settings_animation: "Animation",
  Node9Settings_animation0: "Disabled",
  Node9Settings_animation1: "Random",
  Node9Settings_animation2: "HUE Circle",
  Node9Settings_default: "Default Color",
  Node2Settings_setAsDefault: "Set as default color",
  Node9Settings_colorPickerType: "Color Palette",
  LuxinWidget_RGBW: "RGBW Controller",
  AddNewWidget_rgbwDescription: "A Color Palette to control your RGBW strip.",
  AddRGBWWidget_button: "Save",
  HubSettings_title5: "Voice Assistant",
  HubSettings_button8: "Amazon Alexa",
};
